import styled from 'styled-components';

const OverviewContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  flex-direction: row;

  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    flex-direction: column;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    flex-direction: column;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    flex-direction: row;
  }
`;

const OverviewTitle = styled.div`
  ${(props) => props.theme.font.heading.v100};
  font-weight: ${(props) => props.theme.font.weight.v300};
  color: ${(props) => props.theme.color.primary.v600};
  padding: 0 0 10px 0;
  text-transform: uppercase;
`;

const OverviewRow = styled.div`
  display: flex;
  flex-direction: column-reverse;
  margin: 0;

  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    &:first-child {
      margin-bottom: 16px;
    }

    &:last-child {
      margin-bottom: 24px;
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    &:first-child {
      margin-bottom: 24px;
    }

    &:last-child {
      margin-bottom: 24px;
    }
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    &:first-child {
      margin-bottom: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }

  &:last-child {
    padding-bottom: 0;
  }
`;

const OverviewLabel = styled.div`
  display: flex;
  align-items: center;
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: ${(props) => props.theme.font.weight.v200};
  ${(props) => props.theme.font.label.v400};
  font-size: 14px;
`;

const OverviewValue = styled.div<{ isPastDue?: boolean }>`
  color: ${({ isPastDue, theme }) =>
    isPastDue
      ? theme.color.primary.v600
      : '#2f9e44'}; // green-2  https://showroom.cvnacorp.com/carvana-css-theme
  font-weight: ${(props) => props.theme.font.weight.v300}
    ${(props) => props.theme.font.label.v400};
  font-size: 20px;
  margin-bottom: 3px;
`;

const OverviewValueBalance = styled(OverviewValue)`
  color: ${(props) => props.theme.color.primary.v600};
  font-size: 20px;
`;

const TooltipContent = styled.p`
  line-height: 20px;
  color: ${(props) => props.theme.color.neutral.v200};
  font-family: ${(props) => props.theme.font.family};
  margin: 0;
`;

const OverviewRowContainer = styled.div`
  display: flex;
  justify-content: space-between;
  min-width: 330px;
  flex-direction: row;

  @media (min-width: ${(props) => props.theme.breakpoint.xs}px) {
    flex-direction: row;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    flex-direction: row;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    flex-direction: row;
  }
  @media (max-width: 420px) {
    flex-direction: column;
  }
`;

const OverviewValueContainer = styled.div`
  display: flex;
`;

const ProgressBarContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    margin-left: 86px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    max-width: 424px;
  }
`;

export {
  OverviewContainer,
  OverviewRowContainer,
  OverviewTitle,
  OverviewRow,
  OverviewLabel,
  OverviewValue,
  OverviewValueContainer,
  OverviewValueBalance,
  TooltipContent,
  ProgressBarContainer,
};
